<script setup lang="ts">
import { useFormValidation } from "../../../../../composables/useFormValidation";
import { required } from "../../../../../utils/validation";
import TextInput from "../../../../../components/ui/form/TextInput.vue";
import { api } from "../../../../../api/Api";
import Toast from "../../../../../services/Toast";
import { Permission } from "../../../../../types/auth";
import { ref, onMounted } from "vue";
import ModalFormTemplate from "../../../../../components/ui/Templates/ModalFormTemplate.vue";

const props = defineProps<{
  data?: any | null;
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus";
  title: string | null;
  endPoint: string;
  permissions?: Permission[];
  listCreateName?: string;
  item?: any | null;
}>();

const emit = defineEmits<{
  (e: "save", data: any): void;
  (e: "close"): void;
}>();

const isReadOnly = ref(true);
onMounted(() => {
  isReadOnly.value = props.mode == "view";
  if (props.mode == "create") {
    resetForm();
    setFormData({
      items_id: props.item.id,
      item: props.item.name,
    });
  } else if (props.data) {
    setFormData(props.data);
  }
});

const {
  fields,
  formData,
  setFieldRules,
  validateForm,
  resetForm,
  setFormData,
} = useFormValidation({
  items_id: props.data?.items_id || props.item?.id || "",
  item: props.data?.item || props.item?.name || "",
  code: props.data?.code || "",
  active: props.data?.active || true,
  uid: props.data?.uid || "",
});

setFieldRules("item", [required("Item is required")]);
setFieldRules("code", [required("Barcode is required")]);

const handleSubmit = async (close: boolean, newRecord: boolean) => {
  console.log(props.item);
  if (validateForm()) {
    const action = formData.value.uid != "" ? "update" : "create";
    const response = await api.post(
      (props.endPoint.slice(-1) == "/" || props.endPoint.slice(-1) == "-"
        ? props.endPoint
        : props.endPoint + "/") + action,
      formData.value
    );
    if (response.success == true) {
      Toast.show("saved successfully");
      emit("save", response.data);
      if (close) {
        emit("close");
      } else if (newRecord) {
        resetForm();
      } else {
        setFormData(response.data);
      }
    }
  }
};
</script>
<template>
  <ModalFormTemplate
    :data="data"
    :mode="mode"
    :title="title"
    :showTour="false"
    :endPoint="endPoint"
    :perm="permissions"
    :listCreateName="listCreateName"
    :tabList="[]"
    :formData="formData"
    @save="handleSubmit"
    @close="$emit('close')"
  >
    <template #form>
      <div class="grid md:grid-cols-2 gap-6">
        <TextInput
          v-model="fields.item.value"
          label="Item"
          :readonly="true"
          :error="fields.item.touched ? fields.item.error : null"
          @blur="fields.item.touched = true"
        />

        <TextInput
          v-model="fields.code.value"
          label="Code"
          :readonly="isReadOnly"
          :error="fields.code.touched ? fields.code.error : null"
          @blur="fields.code.touched = true"
        />
      </div>
    </template>
  </ModalFormTemplate>
</template>
